import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, AddSurvey,Addanswers,Answers } from './components';
import {
  Button,
  Dialog,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  actions: {
    textAlign: 'right',
    padding: theme.spacing(3),
    paddingRight: theme.spacing(5),
    '& > * + *': {
      margin: theme.spacing(0)
    }
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});
const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export const EditSurvey = withRouter(props => {
  const history = useHistory();
  const classes = useStyles();
  const [newsobj, setNewsobj] = useState({});
  const [userid, setUserid] = useState('');
  const [viewtype, setViewtype] = useState(1);
  const [selectedanswer, setSelectedanswer] = useState(null);
  const [isaddanswer, setIsaddanswer] = useState(false);
  const [params, setParams] = useState({
    
  });
  const [useranswer, setUseranswer] = useState([]);

  const [masters, setMasters] = useState({
    commodity :[],
    languages:[],
    surveyType: []
  });

  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const snackbarCtx = React.useContext(SnackBarContext);

  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {},false)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {},false)
    let surveyType = [{ name: "Choice", value: 1 }, { name: "Free Text", value: 2 }]
    setMasters({
      ...masters,
      languages : languages.module,
      commodity : commodities.module,
      surveyType : surveyType
    })

    var com_id = props.location.pathname.split('/')[2];
    // var viewtype = props.location.pathname.split('/')[3];
    // setViewtype(viewtype)
    // setUserid(user_id)
   
    if(com_id){
      fetchsurveyinfo(com_id,languages.module,commodities.module,surveyType);
    }
  }
  async function updatenewsinfo()
  {
    let bodycontent = {
      question :  {...params, surveytype: params?.surveytype?.value??null},
      answer : useranswer,
      id : newsobj.id,
    }
    debugger
     let response = await sendNetworkRequest('/admin/addsurvey', {}, bodycontent,false)
      snackbarCtx.setSnack({
        ...snackbarCtx,
        open: true,
        type: "success",
        msg: "Saved Successfully",
        vertical: "top",
      });
      history.push('/survey');

   
  }
  const handleaddanswer = (index) => {
    if(index > -1)
    {
      setSelectedanswer({
        ...useranswer[index],
        index
      })
    } else {
      const maxOrder = useranswer.reduce((max, ans) => {
        const n = parseInt(ans.sortorder, 10);
        return Number.isFinite(n) ? Math.max(max, n) : max;
      }, 0);
      setSelectedanswer({
        sortorder: maxOrder + 1
      })
    }
    setIsaddanswer(!isaddanswer)
  }
  const handleClear = () => {
    
  };
  async function fetchsurveyinfo(newsid,lang,mas_commodities, surveyType)
  {

    let commodities = await sendNetworkRequest('/admin/getsurveyinfo', {}, {id:newsid},false)

    let survey_obj = commodities.module;
    let survey_lang = survey_obj.languages;
    let survey_commodities = survey_obj.commodities;
    let commodity  = []
    if(mas_commodities){

      mas_commodities.map(m_com => {
        if(survey_commodities.indexOf(""+m_com.id) > -1)
        {
          commodity.push(m_com)
        }
      })
    }

    let langs = []
      if(lang){
        lang.map (obj => {
          if(survey_lang.indexOf(""+obj.id) > -1){
            langs.push(obj)
          }
        })
      }

      let questions = {}

      if(survey_obj.survey_questions){
        if(survey_obj.survey_questions.length > 0){
          questions = JSON.parse(survey_obj.survey_questions[0].question)
        }
      }

      let surveytype = null;
      if(surveyType){
        surveytype = surveyType.filter(val => val.value === (survey_obj.answer_type || 1))[0]
      }
      debugger
     let newsobj = {
             id : survey_obj.id,
    //       nameenglish: commodities.title,
    //       descenglish: commodities.description,
    //       nametamil: commodities.titleTamil,
    //       desctamil: commodities.descriptionTamil,
    //       nametelugu: commodities.titleTelugu,
    //       desctelugu: commodities.descriptionTelugu,
             imageurl: survey_obj.imageurl,
    //       videourl: commodities.videourl,
            ...questions,
            surveytype: surveytype,
            commodity : commodity,
            languages : langs
       }

       let user_options = []
       let useranswer_arr = survey_obj.survey_options;
       useranswer_arr.map(obj => {
        let usr_obj = {
            ...obj,

        }
        Object.keys(obj.lang_options).map(key => {
          usr_obj[`answer${key}`] = obj.lang_options[key];
        })
        user_options.push(usr_obj)
       })
       user_options.sort((a, b) => {
        const sa = a.sortorder != null ? a.sortorder : 9999;
        const sb = b.sortorder != null ? b.sortorder : 9999;
        if (sa !== sb) return sa - sb;
        return (a.id || 0) - (b.id || 0);
       })


      setNewsobj(newsobj)
      setUseranswer(user_options)
      setParams({
        id : survey_obj.id,
        mageurl: survey_obj.imageurl,
        commodity : commodity,
        languages : langs,
        surveytype: surveytype,
        ...questions,
      })


   
  }
  useEffect(() => {
    fetchmasters()
 
   
  }, []);
  function handleoptionchange(type, value)  {
   
    setParams(params => ({
      ...params,
      [type]: value
    }));

    //alert(JSON.stringify(value))
  }
  function handleanswer(value)  {
    const parsedOrder = parseInt(value.sortorder, 10);
    const nextValue = {
      ...value,
      sortorder: Number.isFinite(parsedOrder) ? parsedOrder : useranswer.length + 1
    }
    let answers = []
    if(selectedanswer && selectedanswer.index != null)
    {
     
      useranswer.map((ans, index) => {
        if(index == selectedanswer.index)
        {
          answers.push(nextValue)
        }else{
          answers.push(ans)
        }
      })
    }else{
      answers = [...useranswer]
      answers.push(nextValue)
  
    }
    answers.sort((a, b) => {
      const sa = a.sortorder != null ? a.sortorder : 9999;
      const sb = b.sortorder != null ? b.sortorder : 9999;
      if (sa !== sb) return sa - sb;
      return (a.id || 0) - (b.id || 0);
    })
    
    setUseranswer(answers)
    setSelectedanswer(null)
    setIsaddanswer(false)
  }
  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
      <AddSurvey usercontent={newsobj} masters={masters} viewtype={viewtype} 
        onValuechange={handleoptionchange}
      />
    {params?.surveytype?.name === "Choice" &&
      <Answers 
        languages={params.languages ? params.languages : []}
        surveyanswers={useranswer}
        usercontent={newsobj} 
        masters={masters} 
        viewtype={viewtype}
        onAddanswer={handleaddanswer}
      /> 
    }
     <Dialog  aria-labelledby="customized-dialog-title" open={isaddanswer} >
        <DialogTitle id="customized-dialog-title"  onClose={handleaddanswer}>
          Modal title
        </DialogTitle>
        <DialogContent dividers>

     <Addanswers languages={params.languages ? params.languages : []}   usercontent={selectedanswer} masters={masters} viewtype={viewtype} 
      onValuechange={handleanswer}
     /> 
     </DialogContent>
     </Dialog>
      <div className={classes.actions}>
          <Button
            style={{ marginRight: 14 }}
            onClick={handleClear}
            variant="contained"
           
          >
            Clear
          </Button>

          <Button
            
            color="primary"
            type="submit"
            variant="contained"
            onClick={updatenewsinfo}
          >
            Update
          </Button>
        </div>
    </Page>
  );
});

export default EditSurvey;
